export default "__VITE_ASSET__b044fae3__"